<template>
  <div>

    <Loader v-if="loading" cover/>

    <div v-else class="vx-row match-height">
      <!-- UNIVERSITY NEWS -->
      <template v-if="infoTopics && infoTopics.length > 0">
        <div v-for="infoTopic in infoTopics" :key="infoTopic.id"
             class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
          <info-topic-card :info-topic="infoTopic"></info-topic-card>
        </div>
      </template>

      <!-- CLASS ROOM -->
      <template v-if="studentEnrollDetails && studentEnrollDetails.length > 0">
        <div v-for="studentEnrollDetail in studentEnrollDetails"
             :key="studentEnrollDetail.id"
             class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base">
          <class-room-card
            :student-enroll="studentEnrollDetail.studentEnroll"
            :student-enroll-detail="studentEnrollDetail"
            :show-learn-time="showLearnTime"></class-room-card>
        </div>
      </template>

      <!-- CLASS ROOM NOT FOUND -->
      <div v-else class="vx-col w-full">
        <vx-card class="text-center">
          <h5 class="font-weight-normal">{{ $t('home.class-not-found') }}</h5>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import EventBus from '@/event-bus';
import {createNamespacedHelpers} from "vuex";
import {createHelpers} from "vuex-map-fields";
import InfoTopicCard from "@/views/pages/Home/InfoTopic/InfoTopicCard";
import ClassRoomCard from "@/views/pages/Home/ClassRoom/ClassRoomCard";
import store from "@/store";
import StudentUnitLearn from "@/store/modules/student-unit-learn";
import StudentEnrollDetail from '@/store/modules/student-enroll/student-enroll-detail';
import InfoTopic from '@/store/modules/university-news/info-topic/index';
import Student from '@/store/modules/student/index';
import {showLocalNotification, notificationType} from "@/utils/notification";
import Swal from 'sweetalert2';
import moment from 'moment';

if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);
if (!store.state.InfoTopic) store.registerModule(`InfoTopic`, InfoTopic);
if (!store.state.StudentUnitLearn) store.state.registerModule(`StudentUnitLearn`, StudentUnitLearn);
if (!store.state.Student) store.state.registerModule(`Student`, Student);

const {
  mapActions: mapStudentEnrollDetailActions,
} = createNamespacedHelpers(`StudentEnrollDetail`);
const {
  mapActions: mapInfoTopicActions,
} = createNamespacedHelpers(`InfoTopic`);
const {
  mapActions: mapStudentUnitLearnActions,
} = createNamespacedHelpers(`StudentUnitLearn`);
const {
  mapActions: mapStudentActions,
} = createNamespacedHelpers(`Student`);

const {
  mapFields: mapStudentEnrollFields,
} = createHelpers({
  getterType: `StudentEnroll/getField`,
  mutationType: `StudentEnroll/updateField`,
});

export default {
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    InfoTopicCard,
    ClassRoomCard,
  },
  data() {
    return {
      loading: true,
      studentEnrollDetails: [],
      infoTopics: [],
      student: null,
      showLearnTime: true,
    }
  },
  computed: {
    ...mapStudentEnrollFields({studentEnrolls: 'studentEnrolls'}),
  },
  methods: {
    ...mapStudentEnrollDetailActions({
      getStudentEnrollDetailsByCurrentUser: 'getStudentEnrollDetailsByCurrentUser',
      getStudentEnrollDetailsByCurrentUserWhileExam: 'getStudentEnrollDetailsByCurrentUserWhileExam',
    }),
    ...mapInfoTopicActions({
      getInfoTopicsStudentFirstPage: 'getInfoTopicsStudentFirstPage',
    }),
    ...mapStudentUnitLearnActions({
      checkUnsavedLearnTime: 'checkUnsavedLearnTime',
    }),
    ...mapStudentActions({
      getStudentByCurrentUser: 'getStudentByCurrentUser',
      updateStudentInformation: 'updateStudentInformation',
    }),
    async handlerSubjectStudentInformation(){
      const payload = {
        id: this.student.id,
        studentInput: {
          code: this.student.code,
          firstNameLocal: this.student.firstNameLocal,
          lastNameLocal: this.student.lastNameLocal,
          telephone: this.student.telephone,
          email: this.student.email,
          lineId: this.student.lineId,
          studentConfirm: true,
        }
      };
      const result = await this.updateStudentInformation(payload);
      if(result){
        this.student = result;
        showLocalNotification(
          this.$vs,
          this.$t('general.success'),
          this.$t('student.update-success'),
          notificationType.SUCCESS
        );
      }
    },
    async loadData() {
      EventBus.$emit('toggleNav', 'open');

      this.loading = true;

      // temp close for exam
      // await this.checkUnsavedLearnTime();

      const today = moment()
      const startDate = moment('2023-10-13').startOf('d')
      const endDate = moment('2023-10-15').endOf('d')
      if(today.isBetween(startDate, endDate)){
        this.studentEnrollDetails = await this.getStudentEnrollDetailsByCurrentUserWhileExam();
        this.showLearnTime = false;
      }else{
        this.studentEnrollDetails = await this.getStudentEnrollDetailsByCurrentUser();
        this.showLearnTime = true;
      }

      this.infoTopics = await this.getInfoTopicsStudentFirstPage();
      //sort isFix first
      if(this.infoTopics && this.infoTopics.length > 0){
        this.infoTopics.sort(function(x, y) {
          // true values first
          return (x.isFix === y.isFix)? 0 : x? -1 : 1;
          // false values first
          // return (x.isFix === y.isFix)? 0 : x? 1 : -1;
        });
      }

      // temp close for exam
      // await this.checkStudentInformation();

      this.loading = false;
    },
    async checkStudentInformation(){
      this.student = await this.getStudentByCurrentUser();
      if(this.student && !this.student.studentConfirm){
        //show prompt
        this.showDialog();
      }
    },
    showDialog(){
      let lineOfficial = '<p>'+this.$t('student.message-line-1')+'</p>' +
        '<div class="text-center">' +
        '<a href="https://lin.ee/67DCqex" target="_blank">' +
        '<img height="36" border="0" src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png">\n' +
        '</a>' +
        '</div>'
      const url = window.location.href;
      if(url.includes('nation')) {
        lineOfficial = '';
      }
      Swal.mixin({
        confirmButtonText: 'Next &rarr;',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        progressSteps: ['1', '2', '3', '4']
      }).queue([
        {
          title: this.$t('student.prompt-title'),
          html: lineOfficial
        },
        {
          title: this.$t('student.message-line-2'),
          inputLabel: this.$t('student.message-line-3'),
          input: 'text',
          inputValue: this.student.telephone,
          inputValidator: (value) => {
            if (!value) {
              return this.$t('student.please-input')
            }
          }
        },
        {
          title: this.$t('student.message-line-2'),
          inputLabel: this.$t('student.message-line-4'),
          input: 'email',
          inputValue: this.student.email,
          inputValidator: (value) => {
            if (!value) {
              return this.$t('student.please-input')
            }
            if(!this.validateEmail(value)){
              return this.$t('student.please-input-valid-email')
            }
          }
        },
        {
          title: this.$t('student.message-line-2'),
          inputLabel: this.$t('student.message-line-5'),
          input: 'text',
          inputValue: this.student.lineId,
          inputValidator: (value) => {
            if (!value) {
              return this.$t('student.please-input')
            }
          }
        },
      ]).then(async (result) => {
        if (result.value) {
          this.student.telephone = result.value[1];
          this.student.email = result.value[2];
          this.student.lineId = result.value[3];
          Swal.fire({
            title: this.$t('student.your-information'),
            html:
            '<div class="text-left">' +
            '<p>' + this.$t('student.telephone') +': <strong>'+ this.student.telephone + '</strong></p>'+
            '<p>' + this.$t('student.email') +': <strong>'+ this.student.email + '</strong></p>'+
            '<p>' + this.$t('student.line-id') +': <strong>'+ this.student.lineId + '</strong></p>'+
            '</div>'
            ,
            confirmButtonText: this.$t('student.confirm')
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.handlerSubjectStudentInformation();
            }
          })
        }
      })
    },
    validateEmail(email) {
      /* eslint-disable-next-line */
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  async beforeMount() {
    await this.loadData();
  },
}
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}

.card-cover {
  overflow: hidden;
}

.live-label {
  position: absolute;
  right: 0;
  top: 0;
  width: 33%;
  height: 40px;
  margin-left: auto;
  // background: rgba(0, 150, 64, 0.8);
  background: rgba(228, 0, 0, 0.8);
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 12px;
  transition: all 400ms;

  &:hover {
    width: 45%;
  }
}
</style>
